<template>
  <v-app
    id="inspire"
    :class="[
      {
        'box-layout': boxLayout,
        'collapse-sidebar': collapseSidebar
      }
    ]"
  >
    <router-view />
    <StickerMemo
      v-show="showMemo"
      v-for="(memo, index) in stickerMemoList"
      :index="index"
      :key="memo.id || memo.index"
      :memoConfig="memo"
      @deleteMemo="deleteMemoPopup"
      @copyMemo="copyMemo"
      @saveMemo="saveMemo"
      @addMemo="addMemo"
      @activeMemo="activeMemo"
      :hasMaxCount="hasMaxCount"
      :activeMemoUniqueKey="activeMemoUniqueKey"
      :showMemo="showMemo"
    />
    <!-- MsgPopup -->
    <dialog-popup></dialog-popup>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import StickerMemo from '@/components/StickerMemo';
import memoMixin from '@/mixins/memo';

export default {
  name: 'App',
  mixins: [memoMixin],
  components: {
    StickerMemo
  },
  metaInfo() {
    return {
      title: `클라우드기반의 채팅상담 솔루션`,
      titleTemplate: '클라우드게이트 - %s',
      link: [{ rel: 'shortcut icon', type: 'image/png', href: 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/favicon_cg.png' }]
    };
  },
  computed: {
    ...mapGetters(['collapseSidebar', 'boxLayout', 'selectedLocale'])
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue